module.exports = __webpack_public_path__ + "static/media/flowerbomb.5fb103d8.png";